import React from 'react';

export default function Loader() {
    return (
        <div className="Loader-container">
            <i className="spinner loading icon"/> Loading...
        </div>
    )
}